<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Select Panel Style';
                }
            },
            component_id: {
                default(){
                    return 'panel';
                }
            },
            securedByDesign: {
                required: true,
            },
            doorCore: {
                required: false,
                default: '',
            },
            doorRange: {
                required: false,
                default: '',
            },
            panelCategory: {
              required: true,
            }
        },
        computed: {
            thumbURL(){
                return '/thumb/slab/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/panel?secured_by_design=' + this.securedByDesign + '&door_core=' + this.doorCore + '&door_range=' + this.doorRange + '&panel_category=' + this.panelCategory;
            },
            cache_key(){
                return '_' + this.securedByDesign + '_' + this.doorCore + '_' + this.doorRange + '_' + this.panelCategory;
            },
            passed_filter(){
                var sbd_ready = this.variable_ready(this.securedByDesign);
                var core_ready = this.doorCore !== '' ? this.variable_ready(this.doorCore) : true;
                var range_ready = this.doorRange !== '' ? this.variable_ready(this.doorRange) : true;
                var panel_category_ready = this.panelCategory !== '' ? this.variable_ready(this.panelCategory) : true;

                return sbd_ready && core_ready && range_ready && panel_category_ready;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
